import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { useContext } from 'react';
import { applicationKeys } from '../cache-keys/applicationKeys';
import { useQuery } from 'react-query';
import { loan_application_api } from '@axo/shared/data-access/api';

export function useLoanApplicationRevision(args?: {
  applicationID?: string;
  revision?: number;
}) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = applicationKeys.revision(
    {
      applicationID: args?.applicationID ?? '',
    },
    args?.revision ?? 0,
  );

  return useQuery({
    queryKey: cacheKey,
    queryFn: () =>
      loan_application_api.getLoanApplicationRevision(api)({
        applicationID: args?.applicationID ?? '',
        revision: args?.revision ?? 0,
      }),
    enabled:
      !!state.user.token &&
      Boolean(args?.applicationID) &&
      args?.revision !== undefined,
  });
}
